module.exports = require("!!vue-loader!../node_modules/v-markdown-loader/_cache/README-31.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/README.md
// module id = 115
// module chunks = 4